import * as PropTypes from "prop-types";
import styled from "styled-components";
import Header from "../Header/Header";

export default function TableHeader({ children }) {
  return (
    <div>
      <TopTextWrapper>
        <Header>{children}</Header>
      </TopTextWrapper>
    </div>
  );
}

TableHeader.propTypes = {
  children: PropTypes.any,
};

const TopTextWrapper = styled.div`
  width: 100%;
  h2 {
    text-align: center;
  }
  h4 {
    text-align: center;
  }
`;
